<template>
    <Layout :header="{ text: '保單借款', backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME} }, }">
        <div class="pt-2 pb-6">
            <Process :steps="['同意條款', '選擇保單', '確認資料', '手機驗證',]" :index="0" />
        </div>
        <div class="pb-4">
            <h2 class="font-bold text-2xl">
                請先閱讀服務約定條款
            </h2>
        </div>
        <CaseBox>
            <ul>
                <li v-for="(agreeTerms, idx) in agreeTermsVoList" :key="idx" class="cursor-pointer py-3 flex"
                    :class="{ 'border-t': idx !== 0 }" @click="(_e) => { setInfoBoxBottom(agreeTerms) }">
                    <div>
                        <div class="inline-block w-[20px] h-[20px] rounded-sm border align-bottom text-white"
                            :class="{ 'bg-[#0093C1] border-[#0093C1]': agreeTerms.read }">
                            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                style="width: 18px; height: 18px;">
                                <title>check</title>
                                <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                            </svg>
                        </div>
                    </div>
                    <div class="flex-1 px-3">
                        {{ agreeTerms.title }}
                    </div>
                    <div class="text-[#0093C1]">
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                            style="width: 24px; height: 24px;">
                            <title>chevron-right</title>
                            <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                        </svg>
                    </div>
                </li>
            </ul>
        </CaseBox>
        <ClauseBox v-if="infoBoxBottomData" :infoBoxBottomData="infoBoxBottomData"
            :closeHandle="() => { setInfoBoxBottom(null) }" @updateInfoBoxBottom="updateInfoBoxBottom" />
        <template v-slot:bottom class="fixed">
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="true && !clauseAllOk" @click="goNextPage">
                下一步
            </button>
        </template>
        <Loading :is-loading="isLoading" />
    </Layout>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { getLoanAgreeTerms, postLoanAgreeTerms } from '@/apis/CloudECounter';
import { openPopupCatchMessage } from '@/utils/vfmUtils';
import CaseBox from '@/components/cloudCounter/CaseBox.vue';
import Layout from '@/components/cloudCounter/Layout.vue';
import Process from '@/components/cloudCounter/Process.vue';
import ClauseBox from '@/components/cloudCounter/clauseBox.vue';
import Loading from '@/components/Loading.vue';
import { useRouter, useRoute } from 'vue-router';
import routeName from '@/router/constant';
import { useStore } from 'vuex';

const isLoading = ref(false);
const agreeTermsVoList = ref([]);
const infoBoxBottomData = ref(null);
const clauseAllOk = computed(() => {
    return agreeTermsVoList.value ? agreeTermsVoList.value.every(item => item.read === true) : false;
});
const store = useStore();
const router = useRouter();
const route = useRoute();
const code = route?.meta.code;

/**
 * Event
 */
const setInfoBoxBottom = (item) => {
    infoBoxBottomData.value = (item) || null;
};

const updateInfoBoxBottom = () => {
    fetchPostAgree(infoBoxBottomData.value);
};

const goNextPage = () => {
    router.push({ name: routeName.CLOUD_E_COUNTER_LOAN_SELECT_POLICY });
};

/**
 * API
 */
// API: 雲端E櫃台-預約視訊 3.取得預約視訊條款相關資訊
const fetchAgreeInfo = async () => {
    isLoading.value = true;
    try {
        const resp = await getLoanAgreeTerms();
        agreeTermsVoList.value = resp.data.agreeTermsVoList;
    } catch (e) {
        openPopupCatchMessage(e);
    } finally {
        isLoading.value = false;
    }
};

// API: 雲端E櫃台-預約視訊 4.同意條款
const fetchPostAgree = async (item) => {
    isLoading.value = true;
    const request = {
        uuid: item.uuid,
    };
    try {
        await postLoanAgreeTerms(request);
        item.read = true; // 呼叫同意條款API成功後，才把畫面上的條款打勾
    } catch (e) {
        openPopupCatchMessage(e);
    } finally {
        isLoading.value = false;
    }
};

/**
 * Hook
 */
onMounted(() => {
    fetchAgreeInfo();
    store.dispatch('services/setChangeItemsResult', {
        code: code,
        value: null,
    });
});
</script>

<style scoped lang="scss"></style>
